import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ComponentModule } from './Component/component.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DirectiveModule } from './Directive/directive.module';
import { ToastrModule } from 'ngx-toastr';
import { SharedService } from './Services/shared.service';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    ComponentModule.forRoot(),
    DirectiveModule.forRoot(),    
    ToastrModule.forRoot(
      {
        timeOut: 5000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
      }
    ),
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxSpinnerModule
  ],
  schemas:[
    NO_ERRORS_SCHEMA
  ],
  //added by rahul yadav on 19/7/2021 for interceptor 
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass:SharedService,
      multi: true,
    }
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
